import { render, staticRenderFns } from "./CorralesListTabs.vue?vue&type=template&id=314dea4e"
import script from "./CorralesListTabs.vue?vue&type=script&lang=js"
export * from "./CorralesListTabs.vue?vue&type=script&lang=js"
import style0 from "./CorralesListTabs.vue?vue&type=style&index=0&id=314dea4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports